<template>
    <div id="alluser">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="refresh" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Sélectionner un utilisateur
        </h1>
        <div class="search-wrapper">
            <input type="text" v-model="search" placeholder="Rechercher un utilisateur"/>
            <label>Search title:</label>
        </div>
        <div class="container">
            <div class="textline">
                <input class="modalCheck" type="checkbox" v-model="showParticulier">
                <span>Particulier</span>
                <input class="modalCheck" type="checkbox" v-model="showPro">
                <span>Professionnel</span>
                <button v-on:click="isProHide = !isProHide" class="btnAccordion">
                    <font-awesome-icon v-if="isProHide" icon="angle-up" />
                    <font-awesome-icon v-if="!isProHide" icon="angle-down" />
                </button>
                <input class="modalCheck" type="checkbox" v-model="showArchi">
                <span>Architecte</span>
                <button v-on:click="isArchHide = !isArchHide" class="btnAccordion">
                    <font-awesome-icon v-if="isArchHide" icon="angle-up" />
                    <font-awesome-icon v-if="!isArchHide" icon="angle-down" />
                </button>
                <input class="modalCheck" type="checkbox" v-model="showAssurance">
                <span>Assurance</span>
                <button v-on:click="isInsHide = !isInsHide" class="btnAccordion">
                    <font-awesome-icon v-if="isInsHide" icon="angle-up" />
                    <font-awesome-icon v-if="!isInsHide" icon="angle-down" />
                </button>
                <input class="modalCheck" type="checkbox" v-model="showAgence">
                <span>Agence</span>
                <button v-on:click="isAgHide = !isAgHide" class="btnAccordion">
                    <font-awesome-icon v-if="isAgHide" icon="angle-up" />
                    <font-awesome-icon v-if="!isAgHide" icon="angle-down" />
                </button>
                <input class="modalCheck" type="checkbox" v-model="showEmploy">
                <span>Salarié</span>                
            </div>
            <div v-if="!isAgHide" class="textline">
                <div v-if="listAg.length">
                    <span v-for="(itemAg, indexAg) in listAg" :key="indexAg">
                        <input class="modalCheck" type="checkbox" v-model="itemAg.check">
                        <span>{{itemAg.data.address.lastName}}</span>
                    </span>
                </div>
                <div v-else>
                    <span>Aucune agence inscrite</span>
                </div>
            </div>
            <div v-if="!isInsHide" class="textline">
                <div v-if="listIns.length">
                    <span v-for="(itemIns, indexIns) in listIns" :key="indexIns">
                        <input class="modalCheck" type="checkbox" v-model="itemIns.check">
                        <span>{{itemIns.data.address.lastName}}</span>
                    </span>
                </div>
                <div v-else>
                    <span>Aucune assurance inscrite</span>
                </div>
            </div>
            <div v-if="!isArchHide" class="textline">
                <div v-if="listArch.length">
                    <span v-for="(itemArch, indexArch) in listArch" :key="indexArch">
                        <input class="modalCheck" type="checkbox" v-model="itemArch.check">
                        <span>{{itemArch.data.address.lastName}}</span>
                    </span>
                </div>
                <div v-else>
                    <span>Aucun architecte inscrit</span>
                </div>
            </div>
            <div v-if="!isProHide" class="textline">
                <div v-if="listPro.length">
                    <span v-for="(itemPro, indexPro) in listPro" :key="indexPro">
                        <input class="modalCheck" type="checkbox" v-model="itemPro.check">
                        <span>{{itemPro.data.address.lastName}}</span>
                    </span>
                </div>
                <div v-else>
                    <span>Aucun profesionnel inscrit</span>
                </div>
            </div>
        </div>
        <div v-for="(item, index) in filteredUsers" :key="index">
            <div class="divCard">
                <span class="spanCard">
                    <b>{{ item.address.firstName + " " + item.address.lastName }}</b>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i style="font-size:16px;">{{ getUserInformation(item.idWeweb)}}</i>
                </span>
                <button class="btnCard" v-on:click="goToUserPage(item.idWeweb)"><font-awesome-icon icon="chevron-right" /></button>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Alluser',
        data() {
            return {
                techToSee : {},
                Groups:{},
                listPro:[],
                listAg:[],
                listIns:[],
                listArch:[],
                isProHide : true,
                isAgHide : true,
                isInsHide : true,
                isArchHide : true,
                showParticulier: true,
                showPro: true,
                showArchi: true,
                showAssurance: true,
                showAgence: true,
                showEmploy: true,
                Name:"client",
                Users:[],
                ButtonfilteredUsers:[],
                search: '',
                navWidth:0,
                navMenuVisible:false,
                filAriane: ""
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            goToUserPage(id){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "userdetail", query:{name:id}});
            },    
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            refresh(){
                location.reload();
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },	
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            getUserInformation(id){
                for(var i=0; i<this.Users.length; i++){
                    if(this.Users[i].idWeweb === id){
                        var txt = "";
                        if(this.Users[i].type){
                            txt = txt + this.Users[i].type + "  -  ";
                        }
                        if(this.Users[i].role){
                            txt = txt + this.Users[i].role;
                        }
                        if(this.Users[i].groupdata.length){
                            for(var j=0; j<this.Users[i].groupdata.length; j++){
                                if(this.Users[i].groupdata[j]){
                                    if(this.Users[i].groupdata[j].address){
                                        txt = txt + "  -  "+ this.Users[i].groupdata[j].address.firstName+" "+this.Users[i].groupdata[j].address.lastName;
                                    }
                                }
                            }
                        }
                        return txt;
                    }
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau")){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getUserData();
                }
            },
            async getGroupData(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/groupdata/admin/all');
                if(response.data.groups){
                    this.Groups = response.data.groups;
                        
                    for(var j=0; j<this.Groups.length; j++){
                        if(this.Groups[j].type === "agence immobilière"){
                            this.listAg.push({data:this.Groups[j], check:true})
                        }
                        if(this.Groups[j].type === "assurance"){
                            this.listIns.push({data:this.Groups[j], check:true})
                        }
                        if(this.Groups[j].type === "architecte"){
                            this.listArch.push({data:this.Groups[j], check:true})
                        }
                        if(this.Groups[j].type === "professionnel"){
                            this.listPro.push({data:this.Groups[j], check:true})
                        }
                    }

                }
            },
            async getUserData(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/userdata/admin/all');
                if(response.data.users){
                    this.Users = response.data.users;
                    this.ButtonfilteredUsers = response.data.users;
                        
                    for(var j=0; j<this.Users.length; j++){
                        this.Users[j].searchData = this.Users[j].address.firstName +" "+
                                                    this.Users[j].address.lastName +" "+
                                                    this.Users[j].address.emailAddress +" "+
                                                    this.Users[j].address.phoneNumber +" "+
                                                    this.Users[j].address.company +" "+
                                                    this.Users[j].address.streetNb +" "+
                                                    this.Users[j].address.streetName +" "+
                                                    this.Users[j].address.postalCode +" "+
                                                    this.Users[j].address.city;
                    }
                    this.getGroupData();
                }
            }
        },
        mounted(){
            this.getCookies();
        },
        computed: {
            filteredUsers() {
                return this.ButtonfilteredUsers.filter(user => {
                    return user.searchData.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        },
        watch: {

            listPro : {
                handler: function (val, oldVal){

                    console.log(val+""+oldVal);

                    this.ButtonfilteredUsers = [];

                    for(var j=0; j<this.Users.length; j++){
                        var shouldAdd = true;
                        if(!this.showParticulier && this.Users[j].type === "particulier"){
                            shouldAdd = false;
                        }
                        if(!this.showPro && this.Users[j].type === "professionnel"){
                            shouldAdd = false;
                        }
                        if(!this.showArchi && this.Users[j].type === "architecte"){
                            shouldAdd = false;
                        }
                        if(!this.showAssurance && this.Users[j].type === "assurance"){
                            shouldAdd = false;
                        }
                        if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                            shouldAdd = false;
                        }
                        if(!this.showEmploy && this.Users[j].type === "salarié"){
                            shouldAdd = false;
                        }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        if(shouldAdd){
                            this.ButtonfilteredUsers.push(this.Users[j]);
                        }
                    }  
                },
                  deep: true
            },

            listIns : {
                handler: function (val, oldVal){
                    console.log(val+""+oldVal);

                    this.ButtonfilteredUsers = [];

                    for(var j=0; j<this.Users.length; j++){
                        var shouldAdd = true;
                        if(!this.showParticulier && this.Users[j].type === "particulier"){
                            shouldAdd = false;
                        }
                        if(!this.showPro && this.Users[j].type === "professionnel"){
                            shouldAdd = false;
                        }
                        if(!this.showArchi && this.Users[j].type === "architecte"){
                            shouldAdd = false;
                        }
                        if(!this.showAssurance && this.Users[j].type === "assurance"){
                            shouldAdd = false;
                        }
                        if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                            shouldAdd = false;
                        }
                        if(!this.showEmploy && this.Users[j].type === "salarié"){
                            shouldAdd = false;
                        }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        if(shouldAdd){
                            this.ButtonfilteredUsers.push(this.Users[j]);
                        }
                    }  
                },
                  deep: true
            },

            listArch : {
                handler: function (val, oldVal){
                    console.log(val+""+oldVal);

                    this.ButtonfilteredUsers = [];

                    for(var j=0; j<this.Users.length; j++){
                        var shouldAdd = true;
                        if(!this.showParticulier && this.Users[j].type === "particulier"){
                            shouldAdd = false;
                        }
                        if(!this.showPro && this.Users[j].type === "professionnel"){
                            shouldAdd = false;
                        }
                        if(!this.showArchi && this.Users[j].type === "architecte"){
                            shouldAdd = false;
                        }
                        if(!this.showAssurance && this.Users[j].type === "assurance"){
                            shouldAdd = false;
                        }
                        if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                            shouldAdd = false;
                        }
                        if(!this.showEmploy && this.Users[j].type === "salarié"){
                            shouldAdd = false;
                        }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        if(shouldAdd){
                            this.ButtonfilteredUsers.push(this.Users[j]);
                        }
                    }  
                },
                  deep: true
            },

            listAg : {
                handler: function (val, oldVal){
                    console.log(val+""+oldVal);

                    this.ButtonfilteredUsers = [];

                    for(var j=0; j<this.Users.length; j++){
                        var shouldAdd = true;
                        if(!this.showParticulier && this.Users[j].type === "particulier"){
                            shouldAdd = false;
                        }
                        if(!this.showPro && this.Users[j].type === "professionnel"){
                            shouldAdd = false;
                        }
                        if(!this.showArchi && this.Users[j].type === "architecte"){
                            shouldAdd = false;
                        }
                        if(!this.showAssurance && this.Users[j].type === "assurance"){
                            shouldAdd = false;
                        }
                        if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                            shouldAdd = false;
                        }
                        if(!this.showEmploy && this.Users[j].type === "salarié"){
                            shouldAdd = false;
                        }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        if(shouldAdd){
                            this.ButtonfilteredUsers.push(this.Users[j]);
                        }
                    }  
                },
                  deep: true
            },
            showParticulier : function (){
                this.ButtonfilteredUsers = [];
                        
                for(var j=0; j<this.Users.length; j++){
                    var shouldAdd = true;
                    if(!this.showParticulier && this.Users[j].type === "particulier"){
                        shouldAdd = false;
                    }
                    if(!this.showPro && this.Users[j].type === "professionnel"){
                        shouldAdd = false;
                    }
                    if(!this.showArchi && this.Users[j].type === "architecte"){
                        shouldAdd = false;
                    }
                    if(!this.showAssurance && this.Users[j].type === "assurance"){
                        shouldAdd = false;
                    }
                    if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                        shouldAdd = false;
                    }
                    if(!this.showEmploy && this.Users[j].type === "salarié"){
                        shouldAdd = false;
                    }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                    if(shouldAdd){
                        this.ButtonfilteredUsers.push(this.Users[j]);
                    }
                }         
            },
            showPro : function (){
                this.ButtonfilteredUsers = [];
                        
                for(var j=0; j<this.Users.length; j++){
                    var shouldAdd = true;
                    if(!this.showParticulier && this.Users[j].type === "particulier"){
                        shouldAdd = false;
                    }
                    if(!this.showPro && this.Users[j].type === "professionnel"){
                        shouldAdd = false;
                    }
                    if(!this.showArchi && this.Users[j].type === "architecte"){
                        shouldAdd = false;
                    }
                    if(!this.showAssurance && this.Users[j].type === "assurance"){
                        shouldAdd = false;
                    }
                    if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                        shouldAdd = false;
                    }
                    if(!this.showEmploy && this.Users[j].type === "salarié"){
                        shouldAdd = false;
                    }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                    if(shouldAdd){
                        this.ButtonfilteredUsers.push(this.Users[j]);
                    }
                }         
            },
            showArchi : function (){
                this.ButtonfilteredUsers = [];
                        
                for(var j=0; j<this.Users.length; j++){
                    var shouldAdd = true;
                    if(!this.showParticulier && this.Users[j].type === "particulier"){
                        shouldAdd = false;
                    }
                    if(!this.showPro && this.Users[j].type === "professionnel"){
                        shouldAdd = false;
                    }
                    if(!this.showArchi && this.Users[j].type === "architecte"){
                        shouldAdd = false;
                    }
                    if(!this.showAssurance && this.Users[j].type === "assurance"){
                        shouldAdd = false;
                    }
                    if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                        shouldAdd = false;
                    }
                    if(!this.showEmploy && this.Users[j].type === "salarié"){
                        shouldAdd = false;
                    }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                    if(shouldAdd){
                        this.ButtonfilteredUsers.push(this.Users[j]);
                    }
                }         
            },
            showAssurance : function (){
                this.ButtonfilteredUsers = [];
                        
                for(var j=0; j<this.Users.length; j++){
                    var shouldAdd = true;
                    if(!this.showParticulier && this.Users[j].type === "particulier"){
                        shouldAdd = false;
                    }
                    if(!this.showPro && this.Users[j].type === "professionnel"){
                        shouldAdd = false;
                    }
                    if(!this.showArchi && this.Users[j].type === "architecte"){
                        shouldAdd = false;
                    }
                    if(!this.showAssurance && this.Users[j].type === "assurance"){
                        shouldAdd = false;
                    }
                    if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                        shouldAdd = false;
                    }
                    if(!this.showEmploy && this.Users[j].type === "salarié"){
                        shouldAdd = false;
                    }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                    if(shouldAdd){
                        this.ButtonfilteredUsers.push(this.Users[j]);
                    }
                }         
            },
            showAgence : function (){
                this.ButtonfilteredUsers = [];
                        
                for(var j=0; j<this.Users.length; j++){
                    var shouldAdd = true;
                    if(!this.showParticulier && this.Users[j].type === "particulier"){
                        shouldAdd = false;
                    }
                    if(!this.showPro && this.Users[j].type === "professionnel"){
                        shouldAdd = false;
                    }
                    if(!this.showArchi && this.Users[j].type === "architecte"){
                        shouldAdd = false;
                    }
                    if(!this.showAssurance && this.Users[j].type === "assurance"){
                        shouldAdd = false;
                    }
                    if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                        shouldAdd = false;
                    }
                    if(!this.showEmploy && this.Users[j].type === "salarié"){
                        shouldAdd = false;
                    }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                    if(shouldAdd){
                        this.ButtonfilteredUsers.push(this.Users[j]);
                    }
                }         
            },
            showEmploy : function (){
                this.ButtonfilteredUsers = [];
                        
                for(var j=0; j<this.Users.length; j++){
                    var shouldAdd = true;
                    if(!this.showParticulier && this.Users[j].type === "particulier"){
                        shouldAdd = false;
                    }
                    if(!this.showPro && this.Users[j].type === "professionnel"){
                        shouldAdd = false;
                    }
                    if(!this.showArchi && this.Users[j].type === "architecte"){
                        shouldAdd = false;
                    }
                    if(!this.showAssurance && this.Users[j].type === "assurance"){
                        shouldAdd = false;
                    }
                    if(!this.showAgence && this.Users[j].type === "agence immobilière"){
                        shouldAdd = false;
                    }
                    if(!this.showEmploy && this.Users[j].type === "salarié"){
                        shouldAdd = false;
                    }

                        for(var y=0; y<this.listAg.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(var z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listAg[y].data.idWeweb && !this.listAg[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listArch.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listArch[y].data.idWeweb && !this.listArch[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listIns.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listIns[y].data.idWeweb && !this.listIns[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                        for(y=0; y<this.listPro.length; y++){
                            if(this.Users[j].groupdata){
                                if(this.Users[j].groupdata.length){
                                    for(z=0; z<this.Users[j].groupdata.length; z++){
                                        if(this.Users[j].groupdata[z].idWeweb  === this.listPro[y].data.idWeweb && !this.listPro[y].check ){
                                            shouldAdd = false;
                                        }
                                    }
                                }
                            }
                        }

                    if(shouldAdd){
                        this.ButtonfilteredUsers.push(this.Users[j]);
                    }
                }         
            },
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #alluser {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .greyBack{
        margin:40px;
        background-color: #E5E5E5;
        color:black;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        padding: 10px;
        border: 1px solid;
        border-color:#555;
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }	
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtnDiv{
        position:relative;
    }
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:10px;
        right:10px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: 10px;
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }    
    .notifList{
        margin-bottom: 10px;
    }
    
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box;    /* Firefox, other Gecko */
        box-sizing: border-box;         /* Opera/IE 8+ */
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    .search-wrapper {
        position: relative;
        label {
          position: absolute;
          width: calc(100% - (24px + 2px));
          font-size: 15px;
          color: rgba(0,0,0,.50);
          top: 8px;
          left: 12px;
          z-index: -1;
          transition: .15s all ease-in-out;
          font-family: 'BenchNine', sans-serif;
        }
        input {
          padding: 4px 12px;
          color: rgba(0,0,0,.70);
          border: 1px solid rgba(0,0,0,.12);
          transition: .15s all ease-in-out;
          background: white;
          font-family: 'BenchNine', sans-serif;
          width: calc(100% - (24px + 2px));
          &:focus {
            outline: none;
            transform: scale(1.05);
            & + label  {
              font-size: 13px;
              transform: translateY(-24px) translateX(-12px);
            }
          }
          &::-webkit-input-placeholder {
              font-size: 15px;
              color: rgba(0,0,0,.50);
              font-weight: 100;
          }
        }
    }
    .modalCheck{
        width:30px;
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.5); /* IE */
        -moz-transform: scale(1.5); /* FF */
        -webkit-transform: scale(1.5); /* Safari and Chrome */
        -o-transform: scale(1.5); /* Opera */
        transform: scale(1.5);
        margin-left: 45px;
    }
</style>